<template>
  <v-checkbox
    v-bind="$attrs"
    v-model="model"
    @change="updateInput"
    :label="label"
    :class="inputClasses"
  ></v-checkbox>
</template>

<script>
export default {
  model: {
    prop: 'modelValue',
    event: 'change',
  },
  props: {
    value: { type: String },
    modelValue: { default: '' },
    label: { type: String },
    trueValue: { default: true },
    falseValue: { default: false },
    inputClasses: { type: String },
  },
  computed: {
    model: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
  methods: {
    updateInput(event) {
      // let isChecked = event.target.checked
      if (this.modelValue instanceof Array) {
        let newValue = [...this.modelValue];
        if (event) {
          newValue.push(this.value);
        } else {
          newValue.splice(newValue.indexOf(this.value), 1);
        }
        this.$emit('change', newValue);
      } else {
        this.$emit('change', event ? this.trueValue : this.falseValue);
      }
    },
  },
};
</script>
